export const budgetStructure = [
    {
        key: 'equipment_materials',
        name: 'ÉQUIPEMENTS ET MATÉRIELS',
        subCategories: [
            { key: 'production_machines', name: 'Machines de production' },
            { key: 'quality_control', name: 'Équipements de contrôle qualité' },
            { key: 'tools_accessories', name: 'Outillage et accessoires' },
            { key: 'it_software', name: 'Matériel informatique/logiciels' },
            { key: 'security_equipment', name: 'Équipements de sécurité' },
        ],
    },
    {
        key: 'works_installation',
        name: 'TRAVAUX ET INSTALLATION',
        subCategories: [
            { key: 'civil_engineering', name: 'Génie civil et bâtiment' },
            { key: 'assembly', name: 'Installation et montage' },
            { key: 'connections', name: 'Raccordements (électricité, eau, gaz)' },
            { key: 'specialized_layouts', name: 'Aménagements spécialisés' },
            { key: 'compliance_works', name: 'Mise en conformité' },
        ],
    },
    {
        key: 'studies_engineering',
        name: 'ÉTUDES ET INGÉNIERIE',
        subCategories: [
            { key: 'feasibility_studies', name: 'Études de faisabilité' },
            { key: 'detailed_design', name: 'Conception détaillée' },
            { key: 'plans_specs', name: 'Plans et spécifications' },
            { key: 'project_management_assistance', name: 'Assistance maîtrise d\'ouvrage' },
            { key: 'technical_controls', name: 'Contrôles techniques' },
        ],
    },
    {
        key: 'training_support',
        name: 'FORMATION ET ACCOMPAGNEMENT',
        subCategories: [
            { key: 'operator_training', name: 'Formation opérateurs' },
            { key: 'maintenance_training', name: 'Formation maintenance' },
            { key: 'technical_docs', name: 'Documentation technique' },
            { key: 'startup_support', name: 'Accompagnement au démarrage' },
            { key: 'staff_certification', name: 'Certification du personnel' },
        ],
    },
    {
        key: 'testing_commissioning',
        name: 'TESTS ET MISE EN SERVICE',
        subCategories: [
            { key: 'acceptance_tests', name: 'Tests de réception' },
            { key: 'mandatory_certs', name: 'Certifications obligatoires' },
            { key: 'warranty_period', name: 'Période de garantie' },
            { key: 'corrections_adjustments', name: 'Corrections et ajustements' },
            { key: 'performance_validation', name: 'Validation performance' },
        ],
    },
    {
        key: 'related_costs',
        name: 'FRAIS CONNEXES',
        subCategories: [
            { key: 'financial_costs', name: 'Frais financiers' },
            { key: 'project_insurance', name: 'Assurances projet' },
            { key: 'legal_admin_costs', name: 'Frais légaux et administratifs' },
            { key: 'contingency', name: 'Provisions pour aléas' },
            { key: 'project_management_costs', name: 'Frais de gestion projet' },
        ],
    },
];

export const expenseStatusOptions = {
    provisional: { label: "Prévisionnel", color: "bg-gray-100 text-gray-800" },
    engaged: { label: "Engagé", color: "bg-blue-100 text-blue-800" },
    invoiced: { label: "Facturé", color: "bg-yellow-100 text-yellow-800" },
    paid: { label: "Payé", color: "bg-green-100 text-green-800" },
};